<template>
  <PlatDataPanelSelect class="enrolling-admission-query"
                       :custom-id="customId"
                       :data-types="['site']"
                       site-group
                       siteLabel="选择教学点">
    <template #default="scope">
      <keep-alive>
        <TemplateDataGrid :key="`${scope.site}`"
                          gridId="EnrollStudentAdmissionQueryGrid"
                          studentType="EMBA"
                          v-bind="scope"></TemplateDataGrid>
      </keep-alive>
    </template>
  </PlatDataPanelSelect>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'EnrollingEMBAAdmissionQuery',
  components: {
    PlatDataPanelSelect,
    TemplateDataGrid
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
.enrolling-admission-query {
  height: 100%;
}
</style>
